import DashboardFMPContactUs from './DashboardTiles/DashboardFMPContactUs'
import DashboardFMPLearnMore from './DashboardTiles/DashboardFMPLearnMore'
import DashboardFMPMailingList from './DashboardTiles/DashboardFMPMailingList'

export default function DashboardFMP() {
  const steps = [
    {
      number: 1,
      title: 'You Sign Up',
      text: 'Fill out a quick form with basic information about yourself or your business.'
    },
    {
      number: 2,
      title: 'We Search',
      text: 'Using the data you provide, we match you with all the tax credits, refunds, and settlements you may qualify for.'
    },
    {
      number: 3,
      title: 'We Notify You',
      text: "You'll be notified of what you're eligible for, and we either process your claim directly or guide you through the next steps."
    },
    {
      number: 4,
      title: 'You Get Paid',
      text: "Our process is fast, simple, and built to make sure you don't miss any opportunity."
    }
  ]

  return (
    <div className='w-full'>
      <h2 className='text-2xl font-bold mb-8'>Here's How It Works:</h2>
      <div className='flex flex-wrap justify-center gap-8'>
        {steps.map((step, idx) => (
          <div key={idx} className='flex items-center'>
            <div className='bg-white h-full rounded-xl shadow p-6 w-64'>
              <div className='flex flex-col items-start'>
                <div className='bg-blue-500 text-white w-10 h-10 flex items-center justify-center rounded-full font-bold mb-3'>
                  {step.number}
                </div>
                <h3 className='font-semibold text-blue-600'>{step.title}</h3>
                <p className='text-sm text-gray-600 mt-2'>{step.text}</p>
              </div>
            </div>
            {idx < steps.length - 1 && (
              <div className='hidden md:flex items-center mx-4'>
                <span className='text-blue-500 text-2xl ml-4'>→</span>
              </div>
            )}
          </div>
        ))}
      </div>
      <div className='w-full flex max-sm:flex-col gap-4 mt-7'>
        <DashboardFMPMailingList />
        <DashboardFMPContactUs />
        <DashboardFMPLearnMore />
      </div>
    </div>
  )
}